/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	AppBar,
	Box,
	CssBaseline,
	Toolbar,
	useMediaQuery,
} from '@mui/material';
// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { setMenuOpen } from 'config/customization';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { drawerWidth } from 'utils/constant';
import Header from './Header';
import Sidebar from './Sidebar';

// styles
const Main: any = styled('main', {
	shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }: any) => ({
	...theme.typography.mainContent,
	position: 'relative',
	background: theme.palette.common.bg,
	marginTop: 80,
	paddingTop: 25,
	...(!open && {
		borderRadius: 0,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		[theme.breakpoints.up('md')]: {
			marginLeft: theme.direction === 'rtl' ? 16 : -drawerWidth,
			marginRight: theme.direction === 'rtl' ? -drawerWidth : 0,
			width: `calc(100% - ${drawerWidth}px)`,
		},
		[theme.breakpoints.down('md')]: {
			marginLeft: '20px !important',
			marginRight: '20px',
			width: `calc(100% - ${drawerWidth}px)`,
			padding: '16px',
		},
		[theme.breakpoints.down('sm')]: {
			marginLeft: '0  !important',
			width: `calc(100% - ${drawerWidth}px)`,
			padding: '6px',
			paddingTop: 25,
			marginRight: '0',
		},
	}),
	...(open && {
		borderRadius: 6,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 16,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		width: `calc(100% - ${drawerWidth}px)`,
		marginRight: 0,
		[theme.breakpoints.down('md')]: {
			marginLeft: '20px',
		},
		[theme.breakpoints.down('sm')]: {
			marginLeft: '10px',
		},
	}),
	marginLeft: 0,
}));

// ==============================|| MAIN LAYOUT ||============================== //

const PrivateLayout = () => {
	const theme = useTheme<any>();
	const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));

	// Handle left drawer
	const leftDrawerOpened: any = useSelector(
		(state: any) => state.customization.opened,
	);
	const dispatch = useDispatch();
	const handleLeftDrawerToggle = () => {
		dispatch(setMenuOpen({ opened: !leftDrawerOpened }));
	};

	useEffect(() => {
		dispatch(setMenuOpen({ opened: !matchDownMd }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [matchDownMd]);

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			{/* header */}
			<AppBar
				className='main-header'
				enableColorOnDark
				position='fixed'
				color='inherit'
				elevation={0}
				sx={{
					borderBottom: '1px solid',
					borderColor: theme.palette.grey[200],
					transition: leftDrawerOpened
						? theme.transitions.create('width')
						: 'none',
				}}
			>
				<Toolbar>
					<Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
				</Toolbar>
			</AppBar>

			{/* drawer */}
			<Sidebar
				drawerOpen={leftDrawerOpened}
				drawerToggle={handleLeftDrawerToggle}
			/>

			{/* main content */}
			<Main className='main-content' theme={theme} open={leftDrawerOpened}>
				<div className='left-border'></div>
				<div className='right-border'></div>

				{/* breadcrumb */}
				{/* <Breadcrumbs
					separator={ChevronRightIcon}
					navigation={navigation}
					icon
					title
					rightAlign
				/> */}
				<Outlet />
			</Main>
		</Box>
	);
};

export default PrivateLayout;
